import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  templateUrl: './inactive-user-dialog.component.html',
  styleUrls: ['./inactive-user-dialog.component.scss'],
  standalone: false,
})
export class InactiveUserDialogComponent {
  private dialog =
    inject<MatDialogRef<InactiveUserDialogComponent>>(MatDialogRef);

  public close(): void {
    this.dialog.close();
  }
}
